import { atom } from "recoil";

const historymeditationAtom = atom({
  key: "historymeditationState",
  default: JSON.parse(localStorage.getItem("history")) ?? [],
});

export default historymeditationAtom;
